// 物流信息
import { utils } from "@/utils";
import { useCorpSettingStore } from "@/stores";
import { t } from "@/utils/i18n";
import styles from "./LogisticsInfo.module.less";
import freeShipIcon from "@/assets/img/icon/free-ship.png";
import PickTypeLabel from "@/components/PickTypeLabel";
import { PhoneFill } from "antd-mobile-icons";


const SHOW_COD_FEE = false;
const { kilobitFormat, px2rem } = utils;
interface LogisticsInfo {
  [key: string]: any;
}
interface LogisticsInfoProps {
  orderExtendEntity: LogisticsInfo;
}

function LogisticsInfo(props: LogisticsInfoProps) {
  const {
    factShippingFee: shippingFee = 0,
    factCodFee: codServiceFee = 0,
    logisticsName = "",
    distributeType,
    distributeCountry = "",
    distributeProvince = "",
    distributeCity = "",
    distributeDistrict = "",
    contractName,
    contractPhone,
    shippingType,
    crossBorder,
  } = props.orderExtendEntity;

  const { corpSetting } = useCorpSettingStore();
  const { currencySymbol } = corpSetting;
  return (
    <div className={styles["logistics-wrap"]}>
      {/* 物流配送 */}
      {distributeType === 4 && (
        <div className={styles["logistics"]}>
          <div className={styles["title"]}>
            <PickTypeLabel pickType={1} className={styles["tag"]} shippingType={shippingType} crossBorder={crossBorder} />
            {logisticsName}
          </div>
          <p className={styles["desc"]}>
            {SHOW_COD_FEE && !!shippingFee && (
              <>
                {t("运输费")} {currencySymbol} {kilobitFormat(shippingFee)}
              </>
            )}
            {SHOW_COD_FEE && !shippingFee && <img src={freeShipIcon} className={styles["free-ship-icon"]} />}
            {SHOW_COD_FEE && <span>
              <span className={styles["margin-s"]}>+</span>
              {t("COD服务费")} {currencySymbol} {kilobitFormat(codServiceFee)}
            </span>}
          </p>
        </div>
      )}
      {/* 自提 */}
      {distributeType === 3 && (
        <div className={styles["pickup"]}>
          <p className={styles["text-wrap"]}>
            <span className={styles["text-item"]}>{contractName}</span>
            <span className={styles["text-item"]}>{contractPhone}</span>
          </p>
          <div className={styles["title"]}>
            <div className={`${styles["pickup-name"]}`}>
              <PickTypeLabel pickType={0} className={styles["tag"]} shippingType={shippingType} crossBorder={crossBorder} />
              <span className={`${styles['logistics-name']} ep-2`}>{logisticsName}</span>
            </div>
            <a className={styles["pickup-tel"]} href={'tel:' + contractPhone}>
              <PhoneFill fontSize={px2rem(26)} color="#4080FF" /> {t("联系我们")}
            </a>
          </div>
          <p className={styles["desc"]}>
            {distributeCountry}
            {distributeProvince}
            {distributeCity}
            {distributeDistrict}
          </p>
        </div>
      )}
    </div>
  );
}

export default LogisticsInfo;
